module.exports = __webpack_public_path__ + "static/media/map.b6ade0d8.svg";